//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

export const SHOP_TAGS_METRICS_ACTIONS = {
  FETCH_SHOP_TAGS_METRICS: 'FETCH_SHOP_TAGS_METRICS',
  SORT_SHOP_TAGS_METRICS: 'SORT_SHOP_TAGS_METRICS',
  DOWNLOAD_SHOP_TAGS_METRICS: 'DOWNLOAD_SHOP_TAGS_METRICS',
  CHANGE_DATE_RANGE: 'CHANGE_DATE_RANGE',
  REQUEST_SUMMARY_STATS: 'REQUEST_SUMMARY_STATS',
  RECEIVE_AGGREGATE_STATS: 'RECEIVE_AGGREGATE_STATS',
  RECEIVE_TREND_STATS: 'RECEIVE_TREND_STATS',
  FETCH_SHOP_TAGS_PRODUCTS: 'FETCH_SHOP_TAGS_PRODUCTS',
  RECEIVE_SHOP_TAGS_PRODUCTS: 'RECEIVE_SHOP_TAGS_PRODUCTS',
  UPDATE_INSIGHTS_METADATA: 'UPDATE_INSIGHTS_METADATA',
  CHANGE_TRENDS_SELECTED_VALUE: 'CHANGE_TRENDS_SELECTED_VALUE',
  RECEIVE_TAG_STATS: 'RECEIVE_TAG_STATS',
  CHANGE_SHOP_TAGS_TABLE_PARAMS: 'CHANGE_SHOP_TAGS_TABLE_PARAMS',
  RECEIVE_TAG_COUNT: 'RECEIVE_TAG_COUNT',
  RECEIVE_EXPORT_URL: 'RECEIVE_EXPORT_URL',
  RECEIVE_EXPORT_REQUEST_MODEL: 'RECEIVE_EXPORT_REQUEST_MODEL',
  SET_SOURCE_TYPE: 'SET_SOURCE_TYPE',
  RECEIVE_EXPORT_FILENAME: 'RECEIVE_EXPORT_FILENAME',
};

export const SHOP_TAGS_TREND_VALUES = {
  TOTAL_TRANSACTIONS: 'transactions',
  TOTAL_REVENUE: 'revenue',
  TOTAL_VISITS: 'ecomSessions',
};

export const SHOP_TAGS_TREND_VALUE_LABELS = {
  [SHOP_TAGS_TREND_VALUES.TOTAL_TRANSACTIONS]: 'Total Transactions',
  [SHOP_TAGS_TREND_VALUES.TOTAL_REVENUE]: 'Total Revenue',
  [SHOP_TAGS_TREND_VALUES.TOTAL_VISITS]: 'Total Visits',
};
